function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useRef as m } from "react";
import { microTask as s } from "../utils/micro-task.js";
import { useEvent as p } from "./use-event.js";
import { useWindowEvent as u } from "./use-window-event.js";

var C = function (n) {
  return n[n.None = 1] = "None", n[n.IgnoreScrollbars = 2] = "IgnoreScrollbars", n;
}(C || {});

function w(c, f) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var i = m(!1),
      l = p(function (r) {
    if (i.current) return;
    i.current = !0, s(function () {
      i.current = !1;
    });

    var a = function t(e) {
      return typeof e == "function" ? t(e()) : Array.isArray(e) || e instanceof Set ? e : [e];
    }(c),
        o = r.target;

    if (!!o.ownerDocument.documentElement.contains(o)) {
      if ((n & 2) === 2) {
        var t = 20,
            e = o.ownerDocument.documentElement;
        if (r.clientX > e.clientWidth - t || r.clientX < t || r.clientY > e.clientHeight - t || r.clientY < t) return;
      }

      var _iterator = _createForOfIteratorHelper(a),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t = _step.value;
          if (_t === null) continue;

          var _e = _t instanceof HTMLElement ? _t : _t.current;

          if (_e != null && _e.contains(o)) return;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return f(r, o);
    }
  });
  u("pointerdown", l), u("mousedown", l);
}

export { C as Features, w as useOutsideClick };